import _ from 'underscore';

export default class StocklistSpecs {
  constructor($scope, ProductService) {
    function load_categories() {
      $scope.categories = [];
      ProductService.get_categories().then(function(response) {
        $scope.categories = response.data.categories;
      });
    }

    $scope.get_category = function(category_id) {
      var category = _.findWhere($scope.categories, category_id);
      if (category) {
        return category.title;
      } else {
        return null;
      }
    };

    $scope.add = function() {
      if (!$scope.filter.specs) {
        $scope.filter.specs = [];
      }

      var spec = {
        stock_type: 'reels',
        edit: true,
      };
      $scope.filter.specs.push(spec);
    };

    $scope.save = function(spec) {
      delete spec.edit;
    };

    $scope.edit = function(spec) {
      spec.edit = true;
    };

    $scope.delete = function(spec) {
      if (confirm('Are you sure you want to delete these specs?')) {
        $scope.filter.specs.splice(_.indexOf($scope.filter.specs, spec), 1);
      }
    };

    $scope.get_spec_partial = function(spec) {
      if (spec.edit) {
        return 'spec_edit.html';
      } else {
        return 'spec_view.html';
      }
    };

    $scope.init = function() {
      load_categories();
    };

    $scope.init();

  }
}

StocklistSpecs.$inject = ['$scope', 'ProductService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/stocklist-specs.ctrl.js